import React, { Component } from 'react';
import { connect } from 'react-redux';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import '../../utils.css'
import Typography from '@material-ui/core/Typography';
import { getCurrentFunctionName } from '../../performanceModeManager';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import { setSelectedType, setSelectedState, setStartDate, setEndDate, setDisplayAllAffairs, setFilteredAndSortedAffairs, setDisplayAsList } from '../../redux/affair/affairActions';
import { ALL_SELECT_OPTION } from '../../constants';
import { Fab, FormControlLabel, Hidden, Icon, Switch } from '@material-ui/core';
import { formatStatus } from '../../redux/affair/affairStatus';
import { formatType } from '../../redux/affair/affairTypes';
import CustomizedSelect from '../Input/CustomizedSelect';

class AffairsFilters extends Component {
    onTypeChange(e) {
        this.props.setSelectedType(e.target.value)
    }

    onStateChange(e) {
        this.props.setSelectedState(e.target.value)
    }

    onStartDateChange(date) {
        this.props.setStartDate(date);
    }

    onEndDateChange(date) {
        this.props.setEndDate(date);
    }

    setDisplayAllAffairs() {
        this.props.setDisplayAllAffairs(!this.props.affairs.displayAllAffairs)
    }

    search() {
        this.props.setFilteredAndSortedAffairs({ ...this.props.affairs }, this.props.tableState,
            this.props.activeUser, this.props.sites.selectedSite, this.props.sites.sites, this.props.tableState.nbTotalResults)
    }

    setDisplayAsList() {
        this.props.setDisplayAsList(!this.props.affairs.displayAsList)
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        let stateElements = this.props.affairs.states.map((s) => (
            <MenuItem key={s} value={s}>
                <Typography variant="inherit" noWrap>{formatStatus(s)}</Typography>
            </MenuItem>
        ))

        stateElements.unshift(
            <MenuItem key={"none"} value={ALL_SELECT_OPTION}>
                {"Tous"}
            </MenuItem>
        )

        let typesElement = this.props.affairs.types.map((t) => (
            <MenuItem key={t} value={t}>
                <Typography variant="inherit" noWrap>{formatType(t)}</Typography>
            </MenuItem>
        ))

        typesElement.unshift(
            <MenuItem key={"none"} value={ALL_SELECT_OPTION}>
                {"Tous"}
            </MenuItem>
        )

        let searchBtnElement = (
            <Fab variant="extended" type="submit" className="element-right" color="secondary" onClick={this.search.bind(this)}>
                <Icon>search</Icon>
                Rechercher
            </Fab>
        );

        return (
            <Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-margin filters-card">
                <CardContent className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding">
                    <FormControl className="col-lg-3 col-md-4 col-sm-6 col-12 control-padding-right-padding" >
                        <InputLabel htmlFor="type">{"Type"}</InputLabel>
                        <CustomizedSelect id="type" name="type" value={this.props.affairs.selectedType}
                            onChange={this.onTypeChange.bind(this)}>
                            {typesElement}
                        </CustomizedSelect>
                    </FormControl>
                    <FormControl className="col-lg-3 col-md-4 col-sm-6 col-12 control-padding-right-padding" >
                        <InputLabel htmlFor="state">{"Etat"}</InputLabel>
                        <CustomizedSelect id="state" name="state" value={this.props.affairs.selectedState}
                            onChange={this.onStateChange.bind(this)}>
                            {stateElements}
                        </CustomizedSelect>
                    </FormControl>
                    <FormControl className="col-lg-3 col-md-4 col-sm-6 col-12 control-padding-right-padding">
                        <MuiPickersUtilsProvider
                            locale={"fr"}
                            utils={MomentUtils}
                            moment={moment}
                        >
                            <DatePicker
                                name="start-date"
                                value={this.props.affairs.startDate}
                                onChange={this.onStartDateChange.bind(this)}
                                label="Du"
                                clearable
                                clearLabel="Effacer"
                                invalidDateMessage="La date est invalide"
                                invalidLabel="La date est invalide"
                                cancelLabel="Annuler"
                                format="DD/MM/YYYY"
                                className="full_size"
                            />
                        </MuiPickersUtilsProvider>
                    </FormControl>
                    <FormControl className="col-lg-3 col-md-4 col-sm-6 col-12 control-padding-right-padding">
                        <MuiPickersUtilsProvider
                            locale={"fr"}
                            utils={MomentUtils}
                            moment={moment}
                        >
                            <DatePicker
                                name="end-date"
                                value={this.props.affairs.endDate}
                                onChange={this.onEndDateChange.bind(this)}
                                label="Au"
                                clearable
                                clearLabel="Effacer"
                                invalidDateMessage="La date est invalide"
                                invalidLabel="La date est invalide"
                                cancelLabel="Annuler"
                                format="DD/MM/YYYY"
                                className="full_size"
                            />
                        </MuiPickersUtilsProvider>
                    </FormControl>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 control-padding-right-padding without-side-margin control-margin-top element-right">
                        <FormControlLabel className={"element-right control-margin-top span-center-verticaly"} control={
                            <Switch value={'valide'} color="secondary"
                                onChange={this.setDisplayAllAffairs.bind(this)}
                                checked={this.props.affairs.displayAllAffairs} />
                        } label={this.props.affairs.displayAllAffairs ? "Toutes" : "En cours"} >
                        </FormControlLabel>
                    </div>
                    <Hidden only={['sm', 'xs']}>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12 control-padding-right-padding without-side-margin control-margin-top row switch-label">
                            <div className="offset-xl-1 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 right span-center-verticaly without-side-padding">
                                <span className={!this.props.affairs.displayAsList ? "green-selected-label" : ""}>Cartes</span>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-4 col-sm-4 col-4 without-side-padding div-center">
                                <Switch onChange={this.setDisplayAsList.bind(this)}
                                    checked={this.props.affairs.displayAsList}
                                    className="switch" color="default"
                                    label={"Liste"} />
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 without-side-padding span-center-verticaly">
                                <span className={this.props.affairs.displayAsList ? "green-selected-label" : ""}>Liste</span>
                            </div>
                        </div>
                        <div className="offset-lg-3 col-lg-3 control-margin-top">
                            {searchBtnElement}
                        </div>
                    </Hidden>
                    <Hidden only={['xl', 'lg', 'md']}>
                        <div className="offset-md-0 col-md-4 offset-sm-0 col-sm-6 offset-4 col-8 control-margin-top">
                            {searchBtnElement}
                        </div>
                    </Hidden>
                </CardContent>
            </Card>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        affairs: state.affairs,
        activeUser: state.activeUser,
        tableState: state.tableState,
        sites: state.sites
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSelectedType: (value) => dispatch(setSelectedType(value)),
        setSelectedState: (value) => dispatch(setSelectedState(value)),
        setStartDate: (value) => dispatch(setStartDate(value)),
        setEndDate: (value) => dispatch(setEndDate(value)),
        setDisplayAllAffairs: (value) => dispatch(setDisplayAllAffairs(value)),
        setFilteredAndSortedAffairs: (affairsFilters, tableState, user, customerSiteId, allSites, nbTotalResults) =>
            dispatch(setFilteredAndSortedAffairs(affairsFilters, tableState, user, customerSiteId, allSites, nbTotalResults)),
        setDisplayAsList: (value) => dispatch(setDisplayAsList(value)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AffairsFilters);
